package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_05_09_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-05-09")
@Composable
public fun Log_2026_05_09(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "I don’t think they saw us!",
        ogTitle = "I don’t think they saw us!",
        date = LocalDate(2_026, 5, 9),
        aiHint = "Image depicts a magical take on a modern (real world) camera and shouldn't be taken literally. The title and description are completely false (joke).",
        ogDescription = "The heroes evaded the surveillance and silenced the alarms. Caper brokered an unlikely alliance, and Dirk found love.",
        ogImage = "images/eyeCamera.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 725,
        ogImageAlt = "A hand-drawn illustration of a surveillance camera with a large bloodshot eye instead of a lens, mounted on a stone wall.",
    ) {
        SessionDayHeader(dayId = "shimmer-31", dateString = "Shimmer 31")
        Log_2026_05_09_Day_1()
        SessionMediaItem(
            image = "images/eyeCamera.webp",
            linkImage = "images/eyeCamera.webp",
            description = "A hand-drawn illustration of a surveillance camera with a large bloodshot eye instead of a lens, mounted on a stone wall.",
            width = 1_200,
            height = 725,
        )
    }
}
